import { render, staticRenderFns } from "./HomeRrisk.vue?vue&type=template&id=0819c144&scoped=true"
import script from "./HomeRrisk.vue?vue&type=script&lang=js"
export * from "./HomeRrisk.vue?vue&type=script&lang=js"
import style0 from "./HomeRrisk.vue?vue&type=style&index=0&id=0819c144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819c144",
  null
  
)

export default component.exports